import { useEffect } from 'react';
import './booking-add-checkout.scss';
import {
  useCreditInUse,
  useCredits,
  useFetchCredits,
  useSetCreditInUse,
} from '../../../store/credits/creditsHooks';
import { useTranslation } from 'react-i18next';
import { getTheRightCredit } from '../../../utility/services/credits-calculate';

type PropsTypes = {
  creditTypes: CreditTypesEnum;
  price: number;
  discount?: number;
  disabledCreditUser?: boolean;
  isPurchasable?: boolean;
  isWaitingListMode?: boolean;
};

export enum CreditTypesEnum {
  COMPANY = 'COMPANY',
  USER = 'USER',
}

const BookingAddCheckout = (props: PropsTypes) => {
  const credits = useCredits();
  const { t } = useTranslation();
  const creditInUse = useCreditInUse();
  const fetchCredits = useFetchCredits();
  const setCreditInUse = useSetCreditInUse();
  const costAfterDiscount =
    // eslint-disable-next-line no-mixed-operators
    props.price - props.price * (props?.discount ? props?.discount / 100 : 0);

  useEffect(() => {
    fetchCredits(props.creditTypes).finally();
  }, []);

  useEffect(() => {
    if (props.disabledCreditUser) {
      setCreditInUse([], 0, costAfterDiscount);
    } else {
      const response = getTheRightCredit(credits, costAfterDiscount);

      setCreditInUse(
        response.credits,
        response.creditInUse,
        response.balanceToPay
      );
    }
  }, [props.price]);

  return (
    <div className="booking-checkout">
      <span className="total-cost">{t('TOTAL_COST')}</span>
      <div className="view-screen">
        <span className="booking-total">₪{costAfterDiscount}</span>
        <span className="original-price">₪{props.price}</span>
        <div className="discount_tag">
          {props.discount}% {t('OFF')}
        </div>
      </div>
      <div className="checkout-line" />
      <span className="total-cost">{t('PAYMENT')}</span>
      <div className="credits-use">
        <span>{t('CREDITS_TAB_LABEL')}</span>
        {creditInUse?.creditsAmount ? (
          <span>{`${creditInUse.creditsAmount}`}</span>
        ) : (
          <span>0</span>
        )}
      </div>
      <div className="cash-use">
        <span>{t('CASH_TAB_LABEL')}</span>
        {creditInUse?.cashAmount ? (
          <span>₪{`${creditInUse?.cashAmount}`}</span>
        ) : (
          <span>₪0</span>
        )}
      </div>
      <div className="checkout-line" />
    </div>
  );
};

export default BookingAddCheckout;
